var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMiHorarioParaCitas = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,264.1c0-9.3,0-18.6,0-27.9c0.3-1.3,0.7-2.7,0.8-4c2.3-33.2,11.1-64.7,27.1-93.8c37-67.1,93.3-108.1,168.7-122.6 c9.1-1.7,18.4-2.5,27.5-3.8c9.3,0,18.6,0,27.9,0c3.4,0.4,6.7,0.8,10.1,1.1c50.2,5.5,94.6,24.7,132.8,57.8 c74.8,64.8,102.6,173.5,65,265C433.1,429.4,361.8,480,261,487.8c-39.1,3-77-4.8-112.2-22.1C75.6,429.8,31,371.6,15.4,291.5 C13.7,282.5,12.9,273.2,11.7,264.1z M249.9,426.8c97.4-0.2,176.6-79.5,176.6-176.7c0-97.2-79.2-176.5-176.6-176.7 c-97.2-0.2-177.2,79.9-176.8,176.9C73.5,347.8,152.9,427,249.9,426.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.1,229.8c11.8,0,52.4-0.4,63.6,0.2c4.9,0.3,10.2,1.7,14.2,4.4c6.7,4.4,9.3,11.5,7.6,19.5c-1.8,8.4-7.4,13.4-15.5,15.6 c-2.2,0.6-4.6,0.8-6.9,0.8c-17.5,0.1-64.3,0.1-81.8,0c-12.9-0.1-21.7-8.3-21.8-21c-0.2-39.4-0.1-100.7,0-140 c0-10.5,6.8-18.7,16.1-20.6c9.1-1.8,18.7,2.7,22.3,11.2c1.5,3.6,2.1,7.8,2.1,11.7c0.2,29.9,0.1,81.8,0.1,111.7 C270.1,225.3,270.1,227.1,270.1,229.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMiHorarioParaCitas, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mi_horario_para_citas.1ee801d9.svg";
export { ForwardRef as ReactComponent };